<script lang="ts" setup>
defineProps<{
  isLoading: boolean
}>()
</script>

<template>
  <button v-if="!isLoading" class="block text-base font-medium leading-6 tracking-tight text-main-green">
    Показать ещё
  </button>
</template>
